export enum TelemetryEventType {
  HeartBeat = 'heartbeat'
}
